/**
 * Utility functions for handling browser cookies.
 */

/**
 * Write a cookie.
 * @param {string} name 
 * @param {string} value 
 * @param {number} days expiration length (defaults to 365)
 */
export const setCookie = (name, value, days = 365) => {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "; expires=" + date.toUTCString();

  let domain = '';
  const hostname = window.location.hostname;
  if (hostname !== 'localhost' && hostname.includes('.')) {
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      domain = `; domain=.${parts.slice(-2).join('.')}`;
    }
  }

  document.cookie = `${name}=${value || ""}${expires}; path=/; SameSite=Lax; Secure${domain}`;
};

/**
 * Read a cookie by name.
 * @param {string} name 
 * @returns {string|null} value of cookie or null
 */
export const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};

/**
 * Erase a cookie.
 * @param {string} name 
 */
export const eraseCookie = (name) => {
  let domain = '';
  const hostname = window.location.hostname;
  if (hostname !== 'localhost' && hostname.includes('.')) {
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      domain = `; domain=.${parts.slice(-2).join('.')}`;
    }
  }
  document.cookie = name + '=; Max-Age=-99999999; path=/; SameSite=Lax; Secure' + domain;
};
